﻿import * as Model from './models';

export interface IEventLogSearchCriteria {
    id: string;
    severity: string;
    application: string;
    logger: string;
    eventTimeFromUtc: Date;
    eventTimeFromLocal: Date;
    activityId: string;
    eventTimeToUtc: Date;
    eventTimeToLocal: Date;
    parentActivityId: string;
    message: string;
    exception: string;
    pagingOptions: Model.IGridPagingOptionsModel;
    sortingOptions: Model.IGridSortingOptionsModel;
}

export class EventLogSearchCriteria {
    id: string;
    severity: string;
    application: string;
    logger: string;
    eventTimeFromUtc: Date;
    eventTimeFromLocal: Date;
    activityId: string;
    eventTimeToUtc: Date;
    eventTimeToLocal: Date;
    parentActivityId: string;
    message: string;
    exception: string;
    pagingOptions: Model.GridPagingOptionsModel;
    sortingOptions: Model.GridSortingOptionsModel;
}